import React, { useContext } from 'react'
import Box from '@material-ui/core/Box'
import { useFormikContext } from 'formik'

import { BudgetContext } from './context'
import { ActionablesContext } from '../../contexts/ActionablesContext'
import { R } from '../../utils/currency'
import { NumberFieldWithLabel, CheckboxWithLabel } from '../../components/Form/Fields'
import { Hider } from '../../components/HOCs/Hider'

export const SimpleBudget = () =>
  <div className='simple-budget'>
    <Main />
  </div>

const Main = () => {
  const { readOnly } = useContext(ActionablesContext)

  return readOnly ? <ReadOnlySimpleBudget /> : <SimpleBudgetInput />
}

const SimpleBudgetInput = () => {
  const { state: { isRetired, minOldAgePension } } = useContext(BudgetContext)
  const { values: { use_current_expense_for_retirement, simple_budget } } = useFormikContext()

  // Constants
  const MIN_OLD_AGE_PENSION = minOldAgePension
  const DEFAULT_PENSION_MESSAGE = `If your retirement expenses are entered as less than R${MIN_OLD_AGE_PENSION}, we'll automatically use R${MIN_OLD_AGE_PENSION} as the default. This reflects the minimum Old Age Pension (SASSA Grant), which we assume will be spent.`

  return (
    <Box className='m-4 flex gap-4'>
      <div className='current-expense flex-1'>
        <NumberFieldWithLabel
          label='Current expenses'
          name='monthly_current_budget'
          subtext='*Exclude asset & liability payments already captured, but include risk product payments'
        />
        { !isRetired &&
          <CheckboxWithLabel
            label='Use current expenses for retirement'
            name='use_current_expense_for_retirement'
            size='small'
          />
        }
      </div>
      <div className='flex-1'>
        <Hider withTransition
          show={!use_current_expense_for_retirement}
          render={() =>
              <NumberFieldWithLabel
                label='Retirement expenses'
                name='simple_budget'
                disabled={use_current_expense_for_retirement}
                subtext={(Number(simple_budget) || 0) < MIN_OLD_AGE_PENSION ?
                  DEFAULT_PENSION_MESSAGE :
                  undefined
                }
              />
            }
        />
      </div>
    </Box>
  )
}

const ReadOnlySimpleBudget = () => {
  const { state: { budget } } = useContext(BudgetContext)
  const { simple_budget, monthly_current_budget } = budget
  const { values: { use_current_expense_for_retirement } } = useFormikContext()
  return (
    <Box m='1rem' ml='2rem' className='budget__read-only-field'>
      <h5>Retirement budget</h5>
      <label>{R(simple_budget).format()}</label>

      { !use_current_expense_for_retirement &&
        <>
          <h5>Current budget</h5>
          <label>{R(monthly_current_budget).format()}</label>
        </>
      }
    </Box>
  )
}
